import { ProgressIndicatorOverlayStateSetterContext } from "../../contexts";
import { useContextSafely } from "../../utils/react-utils";

export function useProgressIndicatorOverlay(suppressErrorMessage?: boolean) {
  return useContextSafely(
    ProgressIndicatorOverlayStateSetterContext,
    suppressErrorMessage,
    useProgressIndicatorOverlay.name
  );
}
